import { render, staticRenderFns } from "./workOrderCraftInfo.vue?vue&type=template&id=588e75a4&scoped=true&"
import script from "./workOrderCraftInfo.vue?vue&type=script&lang=js&"
export * from "./workOrderCraftInfo.vue?vue&type=script&lang=js&"
import style0 from "./workOrderCraftInfo.vue?vue&type=style&index=0&id=588e75a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588e75a4",
  null
  
)

export default component.exports